import React, { useState } from "react";
import moment from "moment-jalaali";
import { ChevronLeft } from "lucide-react";

import "./CommentCard.css";

export default function CommentCard({ comment }) {
  const [open, setOpen] = useState(false);

  const type = comment.commentable_type.split("\\")[2];
  const item = comment.commentable;

  let imagePath = "/images/logo.png";

  // if (type === "Product") {
  //   imagePath =
  //     process.env.REACT_APP_PRODUCT_IMAGE_URL + item.primary_image;
  // } else if (type === "Article") {
  //   imagePath =
  //     process.env.REACT_APP_ARTICLE_IMAGE_URL + item.file;
  // } else {
  //   imagePath =
  //     process.env.REACT_APP_VIDEO_IMAGE_URL + item.file;
  // }

  return (
    <div className="dashboard-comment-card">

      {/* Header */}
      <div
        className="dashboard-comment-header"
        onClick={() => setOpen((value) => !value)}
      >
        <img
          src={imagePath}
          alt=""
          className="dashboard-comment-image"
        />

        <div className="dashboard-comment-meta">

          <span className="dashboard-comment-status">
            تایید شده
          </span>

          <span className="dashboard-comment-date">
            {moment(comment.created_at).format(
              "HH:mm - jYYYY، jMMMM jDD"
            )}
          </span>

        </div>

        <div
          className={`dashboard-comment-arrow ${
            open ? "dashboard-comment-arrow--open" : ""
          }`}
        >
          <ChevronLeft size={20} />
        </div>
      </div>


      {/* Content */}
      {open && (
        <div className="dashboard-comment-content">

          {/* User Comment */}
          <div className="dashboard-comment-text">
            <p>{comment.comment}</p>
          </div>


          {/* Admin Reply */}
          {comment.reply && (
            <div className="dashboard-comment-reply-wrapper">

              <div className="dashboard-comment-reply">

                {/* Reply Header */}
                <div className="dashboard-comment-reply-header">

                  <div className="dashboard-comment-reply-avatar">
                    <img
                      src="/images/logo.png"
                      alt=" کافه دارو "
                    />
                  </div>

                  <div className="dashboard-comment-reply-info">
                    <span> کافه دارو </span>
                  </div>

                </div>


                {/* Reply Body */}
                <div className="dashboard-comment-reply-body">
                  <p>{comment.reply}</p>
                </div>

              </div>

            </div>
          )}

        </div>
      )}

    </div>
  );
}